export default (array, item) => item === array[array.length - 1];
